import { useTranslation } from "react-i18next"
import secondsToHms from "../../../../utility/SecondToHms"
import { useSelector } from "react-redux"
import { selectCompanyGuid } from "features/auth/authSlice"

function AbsenceReportTables({ startDate, endDate, absenceRecords }) {

    const [t] = useTranslation(["global", "absenceReport"])
    const start = new Date(startDate * 1000).toLocaleDateString()
    const end = new Date(endDate * 1000).toLocaleDateString()

    const currentCompanyGuid = useSelector(selectCompanyGuid)
    const apiUrl = process.env.REACT_APP_API_URL

    return (
        <div className="card bg-black bg-opacity-10 text-white mb-4">
            <div className="card-header">
                <i className="fa-solid fa-chart-simple"></i> {t("absenceReport:menu.results")}
            </div>

            <div className="card-body">
                <div className="container text-center">{t("absenceReport:helper.referring_to_period")}
                    <h5> <b>{start}</b> - <b>{end}</b></h5>
                </div><br />



                {absenceRecords.length === 0 ?
                    <div className="text-center opacity-50 p-4"><h3><i className="fa-regular fa-folder-open fa-beat"></i> {t("absenceReport:no_data.no_absences")}</h3></div>
                    :

                    <section>
                        <div className="text-end">
                            <a href={`${apiUrl}/hr/utility/timeReport/pdf?start=${startDate}&end=${endDate}&companyGUID=${currentCompanyGuid}`}><button className="btn btn-primary" ><i className="fa-solid fa-print"></i> PDF</button></a>
                        </div>
                        <br />
                        <table className="table table-dark table-hover text-end">
                            <thead>
                                <tr>
                                    <td><i className="fa-solid fa-user"></i> </td>
                                    <td className="col opacity-50">{t("absenceReport:entity.absence.reason.permitt")} (h)</td>
                                    <td className="col opacity-50">{t("absenceReport:entity.absence.reason.holidays")}</td>
                                    <td className="col opacity-50">{t("absenceReport:entity.absence.reason.sick")}</td>
                                    <td className="col opacity-50">Straordinario</td>
                                    {/* <td className="col">{t("absenceReport:property.total_days")}</td> */}
                                </tr>
                            </thead>
                            <tbody>


                                {absenceRecords.map((userRecord, i) => {
                                    return <tr key={userRecord.userDisplayName}>
                                        {console.log(i)}
                                        <td>{userRecord.userDisplayName}</td>

                                        <td>{userRecord.stats.PERMIT ? userRecord.stats.PERMIT: "-"}</td>

                                        <td>{userRecord.stats.HOLIDAY ? userRecord.stats.HOLIDAY : "-"}</td>

                                        <td>{userRecord.stats.SICK ? userRecord.stats.SICK : "-"}</td>

                                        <td>{userRecord.stats.OVERTIME ? userRecord.stats.OVERTIME : "-"}</td>

                                        {/* <th>{userRecord.totalDays}</th> */}

                                    </tr>
                                })}
                            </tbody>
                        </table>

                    </section>



                }


            </div>

        </div>
    )
}

export default AbsenceReportTables